import { putApi } from '../../../utils/api'

export function updateSearchResultsFlatsTableConfig(data) {
  return putApi({
    data,
    endpoint: 'idwell-api/api/v3/table/tables/flats-search/config/',
  })
}
